import { createReducer } from '../utils';
import {
  CONFIG_SET_SNAPSHOTS_ENABLED,
  CONFIG_SET_WEBSITE_BACKGROUNDS,
  CONFIG_SET_CURRENT_SECTION,
  CONFIG_SET_PREVIOUS_PATH,
  CONFIG_SET_DEFAULT_ITEM,
  CONFIG_SET_INITIAL_LOAD,
  CONFIG_SET_INITIAL_LOAD_ERROR,
  SET_STATIC_PAGE,
  STATIC_PAGE_LOADING,
  CONFIG_SET_BACKGROUND_IMAGE,
  CONFIG_SET_BACKGROUND_RESET,
  CONFIG_SET_LOGO, CONFIG_SET_SERVER_ERROR,
} from '../constants';

const initialState = {
  website_backgrounds: null,
  snapshotsEnabled: null,
  pageContent: '',
  pageTitle: '',
  pageCommentsEnabled: false,
  pageCommentsBoardId: null,
  pageData: {
    css: null,
    show_title: true,
    published: true,
  },
  staticPageLoading: true,
  backgroundImage: '',
  backgroundImageReset: null,
  initialDataLoaded: false,
  initialLoadError: false,
  initialStateCallsCompleted: {
    alerts: false,
    websiteBackgrounds: false,
    gfy: false,
    snapshotsEnabled: false,
    defaultLivecam: false,
    channels: false,
    camgroups: false,
    countries: false,
  },
  serverError: false,
  logo: '/images/ExploreLogoBear.svg',
};

export default createReducer(initialState, {
  [CONFIG_SET_SERVER_ERROR]: (state, payload) => {
    return Object.assign({}, state, { serverError: payload });
  },
  [CONFIG_SET_SNAPSHOTS_ENABLED]: (state, payload) => {
    return Object.assign({}, state, {
      snapshotsEnabled: payload.data,
    });
  },
  [CONFIG_SET_WEBSITE_BACKGROUNDS]: (state, payload) => {
    return Object.assign({}, state, {
      website_backgrounds: payload.data,
    });
  },
  [CONFIG_SET_CURRENT_SECTION]: (state, payload) => {
    return Object.assign({}, state, {
      currentSection: payload.data,
    });
  },
  [SET_STATIC_PAGE]: (state, payload) => {
    return Object.assign({}, state, {
      pageContent: payload.html,
      pageTitle: payload.title,
      pageCommentsEnabled: payload.disqus,
      disqusThreadVersion: payload.disqus_thread_version,
      pageCommentsBoardId: payload.comment_board_id,
      pageData: {
        css: payload.css,
        show_title: payload.show_title,
        published: payload.published,
        pageUrl: payload.page_url,
      },
    });
  },
  [STATIC_PAGE_LOADING]: (state, payload) => {
    return Object.assign({}, state, {
      staticPageLoading: payload,
    });
  },
  [CONFIG_SET_PREVIOUS_PATH]: (state, payload) => {
    return Object.assign({}, state, {
      previousPath: payload.data,
    });
  },
  [CONFIG_SET_DEFAULT_ITEM]: (state, payload) => {
    return Object.assign({}, state, {
      defaultItem: payload.data,
    });
  },
  [CONFIG_SET_INITIAL_LOAD]: (state, payload) => {
    return Object.assign({}, state, {
      initialLoad: payload.data,
      initialDataLoaded: true,
    });
  },
  [CONFIG_SET_INITIAL_LOAD_ERROR]: (state, payload) => {
    return Object.assign({}, state, {
      initialLoadError: payload.data,
    });
  },
  [CONFIG_SET_BACKGROUND_IMAGE]: (state, payload) => {
    const currentTime = new Date();
    const time = currentTime.setTime(currentTime.getTime() + (1000 * 60));
    return Object.assign({}, state, {
      backgroundImage: payload.data,
      backgroundImageReset: time,
    });
  },
  [CONFIG_SET_BACKGROUND_RESET]: (state, payload) => {
    return Object.assign({}, state, {
      backgroundImageReset: null,
    });
  },
  [CONFIG_SET_LOGO]: (state, payload) => {
    if (!payload.logo) {
      return Object.assign({}, state);
    }
    return Object.assign({}, state, {
      logo: payload.logo,
    });
  },
});
